import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { blobToURL } from '@vindr/utils/converter';
import { queryKey } from '../constants/queryClientKey';

export function useGetPrintPDF(url: string, options?: UseQueryOptions) {
  return useQuery(
    [queryKey.reports, url],
    async () => {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const blob = await response.blob();

      return blobToURL(blob);
    },
    options
  ) as UseQueryResult<string>;
}
